import { OrderCard } from 'components/LightConversation/components/OrderCard';
import { useRef } from 'react';

interface TradeListProps {
  conversation: Conversation.Conversation;
  tradeList: Conversation.Trade.Vo[];
}

export const LightTradeList = (props: TradeListProps) => {
  const { conversation, tradeList } = props;
  const containerRef = useRef<HTMLDivElement>(null);

  return (
    <div className="flex-1 flex flex-col overflow-y-auto pb-3 gap-3 relative" ref={containerRef}>
      {tradeList.map((order) => (
        <OrderCard
          sendable={false}
          key={order.internalTradeId}
          conversation={conversation}
          order={order}
        />
      ))}
    </div>
  );
};
